/* eslint-disable lines-between-class-members */
import { Expose, Type } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { ProductFeatures } from "src/shared/models/policy-features";

export class PolicyProduct extends BaseModel {
    @Expose() category = "";
    @Expose() code = "";
    @Expose() description = "";
    @Expose() icon = "";
    @Expose() systemCode = "";
    @Expose()
    @Type(() => ProductFeatures)
    features = new ProductFeatures();
}
